window.sq = window.sq || {};

function updateRedirectUrl() {
  window.sq.config = window.sq.config || {};

  // Check and update current URL
  let currentUrl = window.location.href;
  if (currentUrl.includes("pages/search-results")) {
    let newUrl = currentUrl.replace("pages/search-results", "search");
    window.location.href = newUrl;
  }
}

updateRedirectUrl();